import type * as AddCustomerOrder from '@ori-events/add-customer-order';
import * as AddCustomerOrderFailed from '@ori-events/add-customer-order-failed';
import type { PositionData } from '@ori/analytics-data';

import type { AddCustomerOrderResponse } from '../guards/addCustomerOrderResponse';
import {
  isCustomerOrderErrorResponse,
  isCustomerOrderSuccessResponse,
} from '../guards/addCustomerOrderResponse';
import { convertToCamelCase, getHttpRequestSettings } from '../helpers';
import { RequestUrl } from '../models';

interface Data extends AddCustomerOrder.Data, PositionData {}

export default async ({ detail: { orderIds, placement } }: CustomEvent<Data>) => {
  const url = new URL(RequestUrl.AddCustomerOrder, window.location.href);
  orderIds.forEach((id) => url.searchParams.append('orderIds', String(id)));

  const request = await fetch(url.toString(), getHttpRequestSettings({ placement }));

  const response = convertToCamelCase<AddCustomerOrderResponse>((await request.json()) as object);

  if (isCustomerOrderSuccessResponse(response)) {
    return {
      ...response,
      lastAddedCustomerOrderIds: orderIds,
    };
  }

  if (isCustomerOrderErrorResponse(response)) {
    const errorEvent = new CustomEvent<AddCustomerOrderFailed.Data>(AddCustomerOrderFailed.Name, {
      detail: response,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return false;
};
